(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pd-banner-picture"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-banner-picture')) {
    customElements.define('pd-banner-picture', class extends HTMLElement {
      connectedCallback() {
        this.image = this.querySelector('img');
        if (!this.image) return;
        this.onLoad = () => {
          this.image.classList.remove('img-loading');
          this.image.classList.add('img-loaded');
        };
        this.image.classList.add('img-loading');
        this.image.addEventListener('load', this.onLoad);
        if (this.image.complete && this.image.naturalWidth > 0) this.onLoad();
      }
      disconnectedCallback() {
        if (this.image && this.onLoad) this.image.removeEventListener('load', this.onLoad);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
